export default class UnitActions {
  static UNIT_FETCH_REQUEST = 'UNIT_FETCH_REQUEST'
  static UNIT_FETCH_SUCCESS = 'UNIT_FETCH_SUCCESS'
  static UNIT_FETCH_ERROR = 'UNIT_FETCH_ERROR'

  static SCHOOL_FETCH_REQUEST = 'SCHOOL_FETCH_REQUEST'
  static SCHOOL_FETCH_SUCCESS = 'SCHOOL_FETCH_SUCCESS'
  static SCHOOL_FETCH_ERROR = 'SCHOOL_FETCH_ERROR'

  static UNIT_CHANGE_REQUEST = 'UNIT_CHANGE_REQUEST'
  static UNIT_CHANGE_SUCCESS = 'UNIT_CHANGE_SUCCESS'
  static UNIT_CHANGE_ERROR = 'UNIT_CHANGE_ERROR'

  static GET_UNIT_REQUEST = 'GET_UNIT_REQUEST'
  static GET_UNIT_SUCCESS = 'GET_UNIT_SUCCESS'
  static GET_UNIT_ERROR = 'GET_UNIT_ERROR'

  static SCHOOL_CHANGE_ACTIVE_PAGE = 'SCHOOL_CHANGE_ACTIVE_PAGE'

  static fetchUnitRequest () {
    return {
      type: UnitActions.UNIT_FETCH_REQUEST
    }
  }
  static fetchUnitSuccess (payload) {
    return {
      type: UnitActions.UNIT_FETCH_SUCCESS,
      payload
    }
  }
  static fetchUnitError (payload) {
    return {
      type: UnitActions.UNIT_FETCH_ERROR,
      payload
    }
  }
  static fetchSchoolRequest () {
    return {
      type: UnitActions.SCHOOL_FETCH_REQUEST
    }
  }
  static fetchSchoolSuccess (payload) {
    return {
      type: UnitActions.SCHOOL_FETCH_SUCCESS,
      payload
    }
  }
  static fetchSchoolError (payload) {
    return {
      type: UnitActions.SCHOOL_FETCH_ERROR,
      payload
    }
  }
  static changeUnitRequest () {
    return {
      type: UnitActions.UNIT_CHANGE_REQUEST
    }
  }
  static changeUnitSuccess (payload) {
    return {
      type: UnitActions.UNIT_CHANGE_SUCCESS,
      payload
    }
  }
  static changeUnitError (payload) {
    return {
      type: UnitActions.UNIT_CHANGE_ERROR,
      payload
    }
  }
  static getUnitRequest () {
    return {
      type: UnitActions.GET_UNIT_REQUEST
    }
  }
  static getUnitSuccess (payload) {
    return {
      type: UnitActions.GET_UNIT_SUCCESS,
      payload
    }
  }
  static getUnitError (payload) {
    return {
      type: UnitActions.GET_UNIT_ERROR,
      payload
    }
  }
  static changeSchoolActivePage (payload) {
    return {
      type: UnitActions.SCHOOL_CHANGE_ACTIVE_PAGE,
      payload
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/unit/actions.js